import type { AgentMessagePart } from '../../types/agent-messages';
import type { ParserContext, ParserResult } from './types';

/**
 * Builds a `thinking` part from tool steps.
 * Pure function -- does not modify the text.
 */
export function thinkingPartBuilder(ctx: ParserContext): ParserResult {
  const parts: AgentMessagePart[] = [];

  if (ctx.toolSteps.length > 0) {
    parts.push({
      type: 'thinking',
      steps: [...ctx.toolSteps],
      duration: ctx.turnDuration,
    });
  }

  return { parts, remainingText: ctx.text };
}
